export enum CoreColumns {
    SummaryItemType = 'summaryItemType',
    OutstandingAmount = 'outstandingAmount',
    OutstandingNumber = 'outstandingNumber',
    BfiRepaysAmount = 'bfiRepaysAmount',
    BfiRepaysNumber = 'bfiRepaysNumber',
    ExternalNumber = 'externalNumber',
}
